import React, { createContext, useEffect } from "react";
import { App } from "antd";
import type { NotificationInstance } from "antd/es/notification/interface";
import { setNotificationApi } from "./apiSetup";

const NotificationContext = createContext<NotificationInstance | null>(null);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { notification } = App.useApp();

  useEffect(() => {
    setNotificationApi(notification);
  }, [notification]);

  return <NotificationContext.Provider value={notification}>{children}</NotificationContext.Provider>;
};
